import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Grid, Stack } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { createVendor, VendorDTO } from 'wisestep-api';
import {
  ControlledTextArea,
  ControlledTextInput,
  WsButton,
  WsLocationSearch,
  WsSelect,
  WsSelectObj,
} from 'wisestep-base';
import { object, string } from 'yup';

import { failed, success } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { vendorDefaultValues } from '../helper/VendorDetailHelper';

const statusOptions: WsSelectObj[] = [
  {
    label: 'Active',
    value: 'true',
  },
  {
    label: 'Inactive',
    value: 'false',
  },
];

interface IVendorProps {
  vendor: VendorDTO | null;
}
const validationSchema = object().shape({
  name: string().required('Please provide Name'),
  email: string().required('Email is required').email('Email is invalid'),
});

const VendorDetailsForm = ({ vendor }: IVendorProps) => {
  const methods = useForm<VendorDTO>({
    resolver: yupResolver(validationSchema),
    defaultValues: vendor ?? vendorDefaultValues,
  });
  const navigate = useNavigate();
  const setNotification = useNotificationStore((state) => state.setNotification);

  const onSubmit = async (data: VendorDTO) => {
    try {
      const resp = await createVendor(data);
      if (resp && resp.data) {
        setNotification(success('Vendor successfully created.'));
        navigate('/vendorslist');
      }
    } catch (err) {
      setNotification(failed('Error while creating vendor.'));
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <Box borderRadius={1.5}>
          <Grid container py={1}>
            <Grid item p={1} sm={5.75}>
              <ControlledTextInput
                name="name"
                type="text"
                fullWidth
                labelText="Vendor Name"
                variant="outlined"
                showMandatorySymbol
              />
            </Grid>
            <Grid item p={1} sm={5.75}>
              <ControlledTextInput
                name="email"
                type="text"
                fullWidth
                labelText="Vendor Email"
                variant="outlined"
                showMandatorySymbol
              />
            </Grid>
            <Grid item p={1} sm={5.75}>
              <ControlledTextInput
                name="legalName"
                type="text"
                fullWidth
                labelText="Legal Name"
                variant="outlined"
              />
            </Grid>
            <Grid item p={1} sm={5.75}>
              <ControlledTextInput
                name="registrationId"
                type="text"
                fullWidth
                labelText="Registration ID"
                variant="outlined"
              />
            </Grid>
            <Grid item p={1} sm={5.75}>
              <WsLocationSearch
                required
                size="small"
                placeHolder="Location"
                name="location"
                variant="outlined"
                multiSelect={false}
                showMandatorySymbol={true}
              />
            </Grid>
            <Grid item p={1} sm={5.75}>
              <WsSelect
                label="Vendor Status"
                name="active"
                selectArray={statusOptions}
                size="small"
              />
            </Grid>
            <Grid item p={1} sm={11.5}>
              <ControlledTextArea name="address" labelText="Address" minRows={5} />
            </Grid>
          </Grid>
        </Box>
        <Stack p={1} spacing={2} direction="row" sx={{ display: 'flex', justifyContent: 'right' }}>
          <WsButton variant="contained" size="medium" onClick={() => console.log('cancel')}>
            {'Back'}
          </WsButton>
          <WsButton variant="contained" size="medium" type="submit">
            {vendor ? 'Update' : 'Save'}
          </WsButton>
        </Stack>
      </form>
    </FormProvider>
  );
};

export default VendorDetailsForm;
